<script lang="ts">
    import { getSeiten } from "../../api"
    import { apiBaseURL } from "../../config"
    import { i18n, sprache } from "../../store"
    import LadeAnimation from "../LadeAnimation.svelte"

    let veranstaltungen: Seite[] = []
    let lade = true

    getSeiten($sprache, null, "veranstaltung").then((r: Seite[]) => {
        veranstaltungen = r
        lade = false
    })
</script>

<div class="collection">
    {#if lade}
        <LadeAnimation />
    {:else}
        {#each veranstaltungen as veranstaltung}
            <div class="post">
                <div class="item">
                    <div class="image">
                        <a href="/{veranstaltung.pfad}"
                            ><img
                                src="{!veranstaltung.bild2?.src?.startsWith(
                                    'data'
                                )
                                    ? apiBaseURL +
                                      '/seiten/' +
                                      veranstaltung.id +
                                      '/' +
                                      veranstaltung.bild2?.src +
                                      '?filter=l'
                                    : veranstaltung.bild2?.src}"
                                alt=""
                            /></a
                        >
                    </div>
                    <div class="text">
                        <h4>{veranstaltung.titel}</h4>
                        {#if veranstaltung.teaserText}
                            {@html veranstaltung.teaserText}
                        {/if}
                        <a href="/{veranstaltung.pfad}" class="btn"
                            >{$i18n("mehr")}</a
                        >
                    </div>
                </div>
            </div>
        {/each}
    {/if}
</div>

<style lang="less">
    @import "../../css/base.less";

    // List
    .post {
        width: 33.3333333%;
        @media (max-width: 1000px) {
            width: 50%;
        }
        @media (max-width: 700px) {
            width: 100%;
            // max-width: 300px;
            // margin: 0 auto;
        }
    }
    .item {
        background: #fff;
        -webkit-box-shadow: 0px 0px 20px 3px rgba(0, 0, 0, 0.1);
        box-shadow: 0px 0px 20px 3px rgba(0, 0, 0, 0.1);
        .transition();
        .image {
            width: 100%;
            height: auto;
            position: relative;
            overflow: hidden;
            img {
                width: 100%;
                height: auto;
                object-fit: cover;
                .transition();
            }
        }
        .text {
            padding: 20px;
            h4 {
                font-size: 1.2rem;
                font-weight: 400;
                margin: 0px 0px 20px 0px;
            }
        }
        &:hover {
            -webkit-box-shadow: 0px 0px 23px 5px rgba(0, 0, 0, 0.2);
            box-shadow: 0px 0px 23px 5px rgba(0, 0, 0, 0.2);
            img {
                transform: scale(1.1);
            }
        }
    }
</style>
